

import ReactDOM from 'react-dom';


function replaceHtmlElementWithComponent(
  htmlElement,
  reactComponent,
  callback=()=>{},
  wrapTagName='div',
  wrapTagId='',
  wrapTagClassList='',
  ) {

  try {
    let parent = htmlElement.parentElement
    let parentChildsCount = parent.childElementCount;

    if (parentChildsCount === 1) {
      ReactDOM.render(reactComponent, parent, callback);
    } else if (parentChildsCount > 1){
      let wrapper = document.createElement(wrapTagName);
      wrapper.classList = wrapTagClassList;
      wrapper.id = wrapTagId;
      parent.insertBefore(wrapper, htmlElement);
      parent.removeChild(htmlElement);
      ReactDOM.render(reactComponent, wrapper, callback);
    } else {
      console.warn("Impossible to replace, no child of the parent element")
    }
  } catch (error) {
    console.error(error);
    debugger;
    console.error(error);
  }
}

export {replaceHtmlElementWithComponent};